export const msTransition = (num: number) => `${num}ms`;